<div class="over">
  <h1 i18n class="over__title">welcome</h1>
  <p i18n class="over__message">
    thank you for downloading this game. the aim is simple: complete rows and/or columns with the pieces at the bottom of your screen to increase your best score. the game is over once you can't place any pieces left.
    <br>
    enable the <strong>hard mode</strong> in the settings if you find the game too simple.
    <br>
    <br>
    enjoy and have fun,
    <br>
    yann
  </p>
</div>

<div
(click)="hide()" class="background"></div>